import { all, put, takeEvery } from "redux-saga/effects";
import { setErrorStatus } from "../status/action";
import store from "../store";
import {
  getInternalLocations,
  getLocationsByLocationIds,
  getProceduresByProcedureIds
} from "../../Services/database";
import { isValidObject } from "../../Services/validators";

export const actionTypes = {
  SET_ACCOUNT_PROFILES: "SET_ACCOUNT_PROFILES"
};

function* setProfilesWorker(action) {
  try {
    yield put({
      type: "SET_PROFILES",
      payload: {
        ...action.payload.profiles,
        linkedProcedures: action.payload.profiles?.linkedProcedures?.filter(
          (data) => data.processing !== true
        )
      }
    });

    const previousConnectedData = store.getState().profile?.data?.connected;
    const currentConnectedData = action.payload?.profiles?.connected;
    const locations = store.getState().locations;
    const procedures = store.getState().procedures;
    const locationIds = Object.keys(locations);
    const procedureIds = Object.keys(procedures);

    if (
      !isValidObject(locations) ||
      arraysAreDifferent(
        currentConnectedData?.location,
        previousConnectedData?.location
      ) ||
      arraysAreDifferent(locationIds, currentConnectedData?.location)
    ) {
      const connectedLocations = yield getLocationsByLocationIds(
        currentConnectedData?.location
      );

      const internalLocations = yield getInternalLocations();

      yield put({
        type: "SET_LOCATIONS_DATA",
        payload: { data: { ...connectedLocations, ...internalLocations } }
      });
    }

    if (
      store.getState().auth.data.claims?.procedures?.read &&
      (!isValidObject(procedures) ||
        arraysAreDifferent(
          currentConnectedData?.procedure,
          previousConnectedData?.procedure
        ) ||
        arraysAreDifferent(procedureIds, currentConnectedData?.procedure))
    ) {
      const response = yield getProceduresByProcedureIds(
        currentConnectedData?.procedure
      );
      yield put({
        type: "SET_PROCEDURES_DATA",
        payload: { data: response }
      });
    }
  } catch (error) {
    setErrorStatus(error);
  }
}

export default function* profileWatcher() {
  yield all([takeEvery("SET_ACCOUNT_PROFILES", setProfilesWorker)]);
}

// function* setProfileLoading(bool) {
//   yield put({
//     type: "SET_PROFILE_LOADING",
//     payload: {
//       loading: bool,
//     },
//   });
// }

function arraysAreDifferent(a, b) {
  // connected.location / connected.procedure can be absent on a profile.
  a = a || [];
  b = b || [];
  if (a.length !== b.length) return true;
  const setA = new Set(a);
  for (const item of b) if (!setA.has(item)) return true;
  return false;
}
